import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';
import { Password } from 'src/app/interfaces/password';
import { Usuario } from 'src/app/interfaces/usuario';

@Injectable({
    providedIn: 'root'
})
export class UsuarioService {

    private baseApiUrl = environment.baseApi;

    constructor(private httpClient: HttpClient) { }

    async obtenerPerfilEmpresaOCandidato(idUsuario: number, rol: string): Promise<any> {
        return await this.httpClient.get<Response>(`${this.baseApiUrl}/privado/usuario/perfil/${idUsuario}/${rol}`).toPromise();
    }

    async obtenerDetallesCandidatoPorId(idCandidato: number): Promise<any> {
        return await this.httpClient.get<Response>(`${this.baseApiUrl}/privado/usuario/candidato/${idCandidato}`).toPromise();
    }

    async obtenerUsuarioExistente(correo: string): Promise<any> {
        return await this.httpClient.get<any>(`${this.baseApiUrl}/publico/usuario/verificar/${correo}`).toPromise();
    }

    crearCuentaEmpresa(body: FormData): Observable<Response> {
        return this.httpClient.post<Response>(`${this.baseApiUrl}/publico/usuario/empresa/registrar`, body);
    }

    crearCuentaCandidato(body: FormData): Observable<Response> {
        return this.httpClient.post<Response>(`${this.baseApiUrl}/publico/usuario/candidato/registrar`, body);
    }

    verificarCuenta(token:string, rol:string){
        return this.httpClient.put<Response>(`${this.baseApiUrl}/publico/usuario/verificar/${rol}`, token);
    }

    actualizarPerfilEmpresa(body: FormData){
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/empresa`, body);
    }

    actualizarPerfilCandidato(body: string){
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/candidato/${false}`, body, { headers });
    }

    actualizarRedesSocialesCandidato(body: string){
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/candidato/${true}`, body, { headers });
    }

    actualizarLogoEmpresa(idUsuario: number, body: FormData){
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/empresa/logo/${idUsuario}`, body);
    }

    actualizarAvatarCandidato(idUsuario: number, body: FormData){
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/candidato/avatar/${idUsuario}`, body);
    }

    actualizarCvCandidato(idUsuario: number, body: FormData){
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/candidato/cv/${idUsuario}`, body);
    }

    actualizarContrasenia(password: Password): Observable<Response> {
        return this.httpClient.put<Response>(`${this.baseApiUrl}/privado/usuario/password`, password);
    }

    reenvioCorreo(usuario: Usuario){
        return this.httpClient.post<Response>(`${this.baseApiUrl}/publico/usuario/reenviar-correo`, usuario);
    }
}
